import { AsianReportViewTypes } from "app/utils/const";
import cx from "classnames";
import dayjs from "dayjs";
import debounce from "lodash/debounce";
import React, { Component, lazy, Suspense } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import ReportPagination from "../../components/ReportPagination/ReportPagination";
import { FooterHelper } from "../../helpers/footerHelper";
import {
  AsianReportViewTypes as ViewTypes,
  AsianStatementTabTypes as TabTypes,
} from "../../utils/const";
import "./AsianStatementScreen.scss";
import AsianStatementScreenCurrentView from "./components/AsianStatementScreenCurrentView/AsianStatementScreenCurrentView";
const AsianReportsHeader: React.LazyExoticComponent<any> = lazy(
  () => import("./components/AsianReportsHeader/AsianReportsHeader")
);
type Props = {
  history: any;
  loadStatementSummaryList: (...args: Array<any>) => any;
  loadStatementNormalList: (...args: Array<any>) => any;
  loadStatementLeagueList: (...args: Array<any>) => any;
  loadStatementMatchList: (...args: Array<any>) => any;
  loadStatementFundingList: (...args: Array<any>) => any;
  resetStatementList: (...args: Array<any>) => any;
  loadStatementExchangeMarkets: (...args: Array<any>) => any;
  loadStatementExchangeBetsPerMarket: (...args: Array<any>) => any;
  totalBets: number;
  pageTotal: number;
  currentView: string;
  before: number;
  after: number;
  marketId: number;
  updateFooterPlacement: (...args: Array<any>) => any;
};
type State = {
  normalViewDate: string;
  page: number;
  tab: string;
  reportPaginationLoaded: boolean;
  footerEndOfPage: boolean;
}; //

const DEFAULT_PAGE_SIZE = 50;
const DEFAULT_FUNDING_PAGE_SIZE = 25;

// A lot of duplicated code with euro statement screen
// Could do with some refactoring to extract common functionality
// Seems main differences are in routing and styling
class AsianStatementScreen extends Component<Props, State> {
  query: string;
  selectedView: string;
  previousView: any;
  timestamp: any;
  debouncedFetchNormalList: any;
  runnerId: any;
  leagueId: any;
  sportId: string | null | undefined;
  startDate: any;
  endDate: any;
  selectedTime: string;
  selectedDateType: string | null | undefined;
  searchBox: HTMLElement | null | undefined;

  constructor(props) {
    super(props);
    this.state = {
      normalViewDate: "",
      page: 1,
      tab: TabTypes.BETTING,
      reportPaginationLoaded: false,
      footerEndOfPage: false,
    };
    this.query = "";
    this.selectedView = ViewTypes.SUMMARY;
    this.timestamp = null;
    this.runnerId = null;
    this.leagueId = null;
    this.sportId = null;
    this.selectedTime = "3months";
    this.selectedDateType = null;
    // Default startDate and endDate to span 3 months
    this.startDate = dayjs().startOf("month").unix();
    this.endDate = dayjs().unix();
    this.debouncedFetchNormalList = debounce(this.fetchStatementList, 500);
    this.fetchStatementList("");
  }

  fetchStatementList = (query: string, page: number = 0) => {
    const before = dayjs(this.timestamp)
      .utc()
      .endOf("day")
      .add("7", "hours")
      .unix();
    const after = dayjs(this.timestamp)
      .utc()
      .startOf("day")
      .add("7", "hours")
      .unix();
    const tab = this.isFundingType(this.selectedDateType)
      ? TabTypes.FUNDING
      : this.state.tab;

    if (this.selectedView === ViewTypes.NORMAL) {
      this.props.loadStatementNormalList({
        tab: tab,
        size: DEFAULT_PAGE_SIZE,
        filter: query,
        page: page,
        before: before,
        after: after,
        runnerId: this.runnerId,
        leagueId: this.leagueId,
        isDetailedView: this.isFundingType(this.selectedDateType),
      });
    } else if (this.selectedView === ViewTypes.LEAGUE) {
      this.props.loadStatementLeagueList({
        tab: tab,
        size: DEFAULT_PAGE_SIZE,
        page: page,
        before: before,
        after: after,
        filter: query,
      });
    } else if (this.selectedView === ViewTypes.MATCH) {
      this.props.loadStatementMatchList({
        tab: tab,
        size: DEFAULT_PAGE_SIZE,
        page: page,
        before: before,
        after: after,
        filter: query,
      });
    } else if (this.selectedView === ViewTypes.SUMMARY) {
      this.props.loadStatementSummaryList({
        tab: tab,
        size: DEFAULT_PAGE_SIZE,
        page: page,
        after: this.startDate,
        sportId: this.sportId,
        before: this.endDate,
        query: query,
      });
    } else if (this.selectedView === TabTypes.FUNDING) {
      this.props.loadStatementFundingList({
        tab: tab,
        size: DEFAULT_PAGE_SIZE,
        page: page,
        filter: query,
        before: before,
        after: after,
        runnerId: this.runnerId,
        leagueId: this.leagueId,
        isDetailedView: this.isFundingType(this.selectedDateType),
      });
    } else if (
      this.props.currentView === AsianReportViewTypes.EXCHANGE_BETTING
    ) {
      this.props.loadStatementExchangeMarkets({
        before: before,
        after: after,
        isDetailedView: true,
        filter: query,
      });
    } else if (
      this.props.currentView === AsianReportViewTypes.EXCHANGE_BETTING_BET
    ) {
      this.props.loadStatementExchangeBetsPerMarket({
        marketId: this.props.marketId,
        filter: query,
      });
    }
  };
  fetchNormalListByType = (type: string, id: any) => {
    this.setState(
      {
        page: 1,
      },
      () => {
        if (type === AsianReportViewTypes.MATCH) {
          this.runnerId = id;
        }

        if (type === AsianReportViewTypes.LEAGUE) {
          this.leagueId = id;
        }

        this.previousView = type;
        this.selectedView = AsianReportViewTypes.NORMAL;
        this.query = "";

        if (
          document.querySelector("#search-events") instanceof HTMLInputElement
        ) {
          (
            document.querySelector("#search-events") as any as HTMLInputElement
          ).value = "";
        }

        this.fetchStatementList(this.query);
      }
    );
  };
  fetchPreviousList = () => {
    this.setState(
      {
        page: 1,
      },
      () => {
        this.runnerId = null;
        this.leagueId = null;
        this.selectedView = this.previousView;
        this.selectedDateType = null;
        this.query = "";

        if (this.selectedView === ViewTypes.SUMMARY) {
          this.fetchStatementList("");
          this.previousView = "";
          this.timestamp = null;
        } else {
          this.previousView = ViewTypes.SUMMARY;
          this.updateQuery(this.query);
        }
      }
    );
  };
  // When using breadcrumbs to navigate back from exchange bets list
  // Loads the previously shown list of exchange markets,
  // by using before and after params from the store
  backToExchangeMarketsByDate = () => {
    const { before, after } = this.props;
    this.props.loadStatementExchangeMarkets({
      filter: "",
      before: before,
      after: after,
      isDetailedView: true,
    });
  };
  onClickNewPage = (pageNumber: number) => {
    this.setState({
      page: pageNumber,
    });
    this.fetchStatementList(this.query, pageNumber);
  };
  onInputChange = (id: string, value: string) => {
    this.query = value;

    if (this.state.page) {
      this.setState({
        page: 1,
      });
    }

    this.updateQuery(value);
  };
  onTypeChange = (event: Record<string, any>) => {
    this.selectedView = event.target.value;
    this.runnerId = null;
    this.leagueId = null;
    this.setState({
      page: 1,
    });
    this.updateQuery(this.query);
  };
  onClickSummaryDate = (timestamp, type) => {
    const before = dayjs(timestamp).utc().endOf("day").add("7", "hours").unix();
    const after = dayjs(timestamp)
      .utc()
      .startOf("day")
      .add("7", "hours")
      .unix();
    const size =
      this.state.tab === TabTypes.FUNDING
        ? DEFAULT_FUNDING_PAGE_SIZE
        : DEFAULT_PAGE_SIZE;

    this.timestamp = timestamp;

    if (this.isFundingType(type)) {
      this.props.loadStatementFundingList({
        size: size,
        page: 0,
        after: after,
        before: before,
        isDetailedView: true,
      });
    } else if (type === AsianReportViewTypes.EXCHANGE_BETTING) {
      this.props.loadStatementExchangeMarkets({
        filter: "",
        before: before,
        after: after,
        isDetailedView: true,
      });
    } else {
      this.props.loadStatementNormalList({
        size: size,
        page: 0,
        filter: "",
        before: before,
        after: after,
        runnerId: null,
        leagueId: null,
      });
    }

    this.selectedDateType = type;
    this.previousView = ViewTypes.SUMMARY;
    this.selectedView = this.isFundingType(type)
      ? TabTypes.FUNDING
      : ViewTypes.NORMAL;
    if (type === AsianReportViewTypes.EXCHANGE_BETTING) {
      this.selectedView = AsianReportViewTypes.EXCHANGE_BETTING;
    }
  };
  onDateChange = (startDate, endDate, time) => {
    if (time) {
      this.selectedTime = time;
    }

    if (startDate && endDate) {
      this.startDate = startDate;
      this.endDate = endDate;
      this.fetchStatementList("");
    }

    this.setState({
      page: 1,
    });
    this.forceUpdate();
  };
  onSportChange = (event: React.SyntheticEvent<HTMLButtonElement>) => {
    this.sportId = event.currentTarget.value;
    this.fetchStatementList("");
    this.setState({
      page: 1,
    });
  };
  resetFilter = () => {
    this.query = "";

    if (document.querySelector("#search-events") instanceof HTMLInputElement) {
      (
        document.querySelector("#search-events") as any as HTMLInputElement
      ).value = "";
    }

    this.fetchStatementList(this.query);
    this.forceUpdate();
  };
  setTab = (tabType: string) => {
    if (this.state.tab === tabType) {
      return null;
    }

    this.setState(
      {
        tab: tabType,
        page: 1,
      },
      () => {
        this.fetchStatementList("");
      }
    );
  };
  updateQuery = (value: string) => {
    const query = value;
    this.debouncedFetchNormalList(query);
  };
  componentDidUpdate = (prevProps: any, prevState: any) => {
    if (prevProps !== this.props) {
      this.calculateFooterPosition();
    }
  };
  calculateFooterPosition = () => {
    // check check where to position Footer component on page
    this.setState({
      footerEndOfPage:
        FooterHelper.checkWhereToPositionFooter("asian-statement"),
    });
  };

  isFundingType(type) {
    return type === "Funding";
  }

  render() {
    const { totalBets, pageTotal, currentView } = this.props;
    const { tab } = this.state;
    let view: any = null;

    view = (
      <AsianStatementScreenCurrentView
        currentView={currentView}
        resetFilter={this.resetFilter}
        query={this.query}
        onClickSummaryDate={this.onClickSummaryDate}
        showBalanceHeaders={
          this.state.tab === TabTypes.ALL && currentView === ViewTypes.SUMMARY
        }
        tab={tab}
        previousView={this.previousView}
        isFundingType={this.isFundingType(this.selectedDateType)}
        fetchNormalListByType={this.fetchNormalListByType}
      />
    );
    return (
      <div className="asian-statement">
        <Suspense fallback={<div className="fallback">loading...</div>}>
          <AsianReportsHeader
            onTypeChange={this.onTypeChange}
            onInputChange={this.onInputChange}
            onSportChange={this.onSportChange}
            onDateChange={this.onDateChange}
            setTab={this.setTab}
            tab={this.state.tab}
            totalBets={totalBets}
            page={this.state.page}
            pageTotal={pageTotal}
            backToPreviousList={this.fetchPreviousList}
            previousView={this.previousView}
            selectedSportId={this.sportId}
            selectedTime={this.selectedTime}
            query={this.query}
            resetFilter={this.resetFilter}
            backToExchangeMarketsByDate={this.backToExchangeMarketsByDate}
          />
        </Suspense>
        <div
          className={cx("asian-statement__content", {
            "asian-statement__content--summary":
              currentView === ViewTypes.SUMMARY,
            "asian-statement__content--filtered": this.query !== "",
            all: this.state.tab === TabTypes.ALL,
            betting: this.state.tab === TabTypes.BETTING,
            funding: this.state.tab === TabTypes.FUNDING,
          })}
        >
          {view}
        </div>
        {pageTotal > 1 &&
          (currentView === ViewTypes.NORMAL ||
            currentView === ViewTypes.SUMMARY) && (
            <ReportPagination
              page={this.state.page}
              pageTotal={pageTotal}
              onClickNewPage={this.onClickNewPage}
            />
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  totalBets: state.statementListModel.statementTotal,
  pageTotal: state.statementListModel.totalPages,
  currentView: state.statementListModel.currentView,
  defaultTab: state.statementListModel.defaultTab,
  before: state.statementListModel.before,
  after: state.statementListModel.after,
  marketId: state.statementListModel.marketId,
});

const mapDispatchToProps = (dispatch: any) => ({
  loadStatementSummaryList: ({
    tab,
    size,
    page,
    sportId,
    after,
    before,
    query,
  }) => {
    dispatch.statementListModel.loadStatementSummaryList({
      tab: tab,
      size,
      page,
      sportId: sportId,
      after: after,
      before: before,
      query: query,
    });
  },
  loadStatementNormalList: ({
    tab,
    size,
    page,
    filter,
    before,
    after,
    runnerId,
    leagueId,
    isDetailedView,
  }) => {
    dispatch.statementListModel.loadStatementNormalList({
      tab: tab,
      size: size,
      page: page,
      filter: filter,
      before: before,
      after: after,
      runnerId: runnerId,
      leagueId: leagueId,
      isDetailedView: isDetailedView,
    });
  },
  loadStatementLeagueList: ({ tab, size, page, filter, before, after }) => {
    dispatch.statementListModel.loadStatementLeagueList({
      tab: tab,
      size: size,
      page: page,
      before: before,
      after: after,
      filter: filter,
    });
  },
  loadStatementMatchList: ({ tab, size, page, filter, before, after }) => {
    dispatch.statementListModel.loadStatementMatchList({
      tab: tab,
      size: size,
      page: page,
      before: before,
      after: after,
      filter: filter,
    });
  },
  loadStatementFundingList: ({
    tab,
    size,
    page,
    filter,
    before,
    after,
    runnerId,
    leagueId,
    isDetailedView,
  }) => {
    dispatch.statementListModel.loadStatementFundingList({
      tab: tab,
      size: size,
      page: page,
      filter: filter,
      before: before,
      after: after,
      runnerId: runnerId,
      leagueId: leagueId,
      isDetailedView: isDetailedView,
    });
  },
  resetStatementList: () => {
    dispatch.statementListModel.resetStatementList();
  },
  loadStatementExchangeMarkets: ({ filter, before, after, isDetailedView }) => {
    dispatch.statementListModel.loadStatementExchangeMarkets({
      filter: filter,
      before: before,
      after: after,
      isDetailedView,
    });
  },
  loadStatementExchangeBetsPerMarket: ({ marketId, filter }) => {
    dispatch.statementListModel.loadStatementExchangeBetsPerMarket({
      marketId: marketId,
      filter: filter,
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(AsianStatementScreen)) as any;
